import {
  MESSAGES_PER_PAGE,
  pageNumberInfinityModel,
  pageNumberInfinityOptions,
} from '../utils/messaging/infinity-model';
import { task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import Service, { service } from '@ember/service';

export default class MessagingConversationService extends Service {
  @service alertManager;
  @service infinity;
  @service intl;
  @service messaging;
  @service store;

  @tracked inactiveReasons = [];
  @tracked messages;
  @tracked selectedConversation;

  openConversationPage(conversation) {
    try {
      this.selectedConversation = conversation;
      this.getMessages.perform();
      if (conversation.inactive) {
        this.fetchInactiveReasons.perform(conversation);
      }
    } catch (e) {
      this.closeConversationPage();
      this.#handleConversationError();
    }
  }

  closeConversationPage() {
    this.selectedConversation = undefined;
    this.messages = undefined;
    this.inactiveReasons = [];
  }

  getMessages = task({ drop: true }, async () => {
    this.messages = await this.infinity.model(
      'messaging-message',
      {
        conversationId: this.selectedConversation.id,
        include: 'user',
        filter: {
          'include_system': this.messaging.currentProfile.isClinician,
        },
        ...pageNumberInfinityOptions(MESSAGES_PER_PAGE),
      },
      pageNumberInfinityModel(MESSAGES_PER_PAGE)
    );
  });

  loadMoreMessages = task({ drop: true }, async model => {
    try {
      await this.infinity.loadNextPage(model);
    } catch (err) {
      this.#handleConversationError();
    }
  });

  fetchInactiveReasons = task({ drop: true }, async conversation => {
    this.inactiveReasons = await this.store
      .adapterFor('messaging-conversation')
      .fetchInactiveReasons(conversation);
  });

  #handleConversationError() {
    this.alertManager.broadcast('toast', {
      message: this.intl.t('general_error'),
      type: 'error',
    });
  }
}
